var getMapData=require("./_getMapData");function mapCacheGet(a){return getMapData(this,a).get(a)}module.exports=mapCacheGet;